import { render, staticRenderFns } from "./attractInvestment.vue?vue&type=template&id=1d48a37e&scoped=true"
import script from "./attractInvestment.vue?vue&type=script&lang=js"
export * from "./attractInvestment.vue?vue&type=script&lang=js"
import style0 from "./attractInvestment.vue?vue&type=style&index=0&id=1d48a37e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d48a37e",
  null
  
)

export default component.exports